module.exports = __webpack_public_path__ + "img/Autocolant TMH_150mm x 180mm-01.7637ef24.jpg";